<template>
  <Paginate
    v-model="localValue"
    :page-count="pages"
    :prev-text="prevent"
    :next-text="next"
    :class="$style.pagination"
    :page-link-class="$style.page"
    :active-class="$style.active"
    :disabled-class="$style.disabled"
    :prev-link-class="$style.prev"
    :next-link-class="$style.next"
    :prev-class="$style.prevWrapper"
    :next-class="$style.nextWrapper"
  />
</template>

<script lang="ts" setup>
import Paginate from 'vuejs-paginate-next';
import { useLocalValue } from '@/hooks/useLocalValue.js';
import type { PaginationEmits, PaginationProps } from './index.js';

const props = defineProps<PaginationProps>();
const emit = defineEmits<PaginationEmits>();

const localValue = useLocalValue(props, emit, 'modelValue');
const prevent = `<svg viewBox="0 0 33 33" fill="none">
  <circle cx="16.5" cy="16.5" r="16.5" fill="#293EFF"/>
  <path d="M19 12L14.1652 16.3513C14.0769 16.4308 14.0769 16.5692 14.1652 16.6487L19 21" stroke="white" stroke-width="2" stroke-linecap="round"/>
</svg>`;
const next = `<svg viewBox="0 0 33 33" fill="none">
  <circle cx="16.5" cy="16.5" r="16.5" transform="matrix(-1 0 0 1 33 0)" fill="#293EFF"/>
  <path d="M14 12L18.8348 16.3513C18.9231 16.4308 18.9231 16.5692 18.8348 16.6487L14 21" stroke="white" stroke-width="2" stroke-linecap="round"/>
</svg>`;
</script>

<style lang="scss" module>
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  user-select: none;
  padding: 50px 0 32px 0;
  margin: 0;
  list-style: none;
}

.page {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: var(--pagi-button-color);
  background-color: var(--pagi-button-bcg-color);
  transition: 150ms ease-in-out;
  cursor: pointer;

  &:hover {
    opacity: .6;
  }
}

.prevWrapper,
.nextWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.prev, .next {
  flex-shrink: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 33px;
  height: 33px;
  transition: 200ms ease;
  cursor: pointer;

  &:hover {
    opacity: .8;
  }
}

.active a {
  color: #121E29;
  user-select: none;
  pointer-events: none;
}

.disabled {

  a {
    user-select: none;
    pointer-events: none;
  }

  svg {
    circle {
      fill: #F8F8F8 !important;
    }

    path {
      stroke: #71787F !important;
    }
  }
}
</style>
